import { Text, View } from "react-native";
import { Button } from "../ui/button";
import StudentMoodItem, { moods } from "./student-mood-item";
import WellbeingInsightsSections from "./wellbeing-insights-sections";

interface LessonReportWellbeingTabProps {
  initialData: {
    aiWellbeingReport: string | null | undefined;
    studentMood: string | null | undefined;
    studentMoodComment: string | null | undefined;
    studentComment: string | null | undefined;
    studentName: string | null | undefined;
  };
  inReview?: boolean;
  onNext?: () => void;
}

function LessonReportWellbeingTab({
  initialData,
  inReview = false,
  onNext,
}: LessonReportWellbeingTabProps) {
  const hasAiReport = !!initialData.aiWellbeingReport?.trim();
  const hasStudentCheckIn = !!initialData.studentMood;

  if (!hasAiReport && !hasStudentCheckIn) {
    return (
      <View className="py-3 px-4 gap-4">
        <Text className="text-base text-center font-geologica-medium font-medium text-black leading-[1.5]">
          No wellbeing reports available yet
        </Text>
        {inReview && onNext ? (
          <View className="mx-10">
            <Button size="sm" outline fullWidth onPress={onNext}>
              <Button.Text size="sm" intent="primary">
                Next
              </Button.Text>
            </Button>
          </View>
        ) : null}
      </View>
    );
  }

  return (
    <View className="gap-6">
      {hasAiReport ? (
        <View className="gap-3">
          <Text className="text-base font-geologica-medium font-medium text-gray-800">
            Session wellbeing insights
          </Text>
          <WellbeingInsightsSections markdown={initialData.aiWellbeingReport!} />
        </View>
      ) : null}

      {hasStudentCheckIn ? (
        <View className="gap-3">
          <Text className="text-base font-geologica-medium font-medium text-gray-800">
            {initialData.studentName
              ? `${initialData.studentName}'s check-in`
              : "Student check-in"}
          </Text>
          <StudentMoodItem
            studentMood={
              moods.find((item) => item.key === initialData.studentMood)
                ?.label ?? ""
            }
            imageKey={initialData.studentMood as string}
            studentMoodComment={initialData.studentMoodComment}
            nonClickable
          />
          {initialData.studentComment?.trim() ? (
            <View className="gap-2 rounded-[17px] border border-gray-200 bg-teachLoop-creamLight px-4 py-3">
              <Text className="text-sm font-geologica-medium text-gray-800">
                In their own words
              </Text>
              <Text className="text-base font-geologica-regular text-teachLoop-textPrimary leading-[1.5]">
                {initialData.studentComment}
              </Text>
            </View>
          ) : null}
        </View>
      ) : (
        <View className="gap-2">
          <Text className="text-base font-geologica-medium font-medium text-gray-800">
            Student check-in
          </Text>
          <Text className="text-base font-geologica-regular text-teachLoop-textPrimary/70 leading-[1.5]">
            The student has not completed their wellbeing check-in yet.
          </Text>
        </View>
      )}

      {inReview && onNext ? (
        <View className="mx-10">
          <Button size="sm" outline fullWidth onPress={onNext}>
            <Button.Text size="sm" intent="primary">
              Next
            </Button.Text>
          </Button>
        </View>
      ) : null}
    </View>
  );
}

export default LessonReportWellbeingTab;
